<template>
  <div class="set-index">
    <SetIndex :menu="menu"></SetIndex>
  </div>
</template>

<script>
import SetIndex from "@/components/set-index/index.vue";
import { ElNotification } from "element-plus";
export default {
  name: "Page",
  components: { SetIndex },
  data() {
    const _this = this;
    return {
      menu: [
        {
          name: "脉动设置",
          icon: require("../../../assets/maidong.png"),
          className: "zhushe",
          arr: [
            { name: "班次设置", to: { name: "adminAutoSet" } },
            { name: "参数设置", to: { name: "adminSetParam" } },
            { name: "设备管理", to: { name: "adminSetDeviceHome" } },
            // { name: "设备管理", to: { name: "DeviceSet" } },
          ],
        },
        {
          name: "系统设置",
          className: "xitong",
          icon: require("../../../assets/chilun@3x.png"),
          arr: [
            // { name: "报警设置", to: { name: "userSetAlarm" } },
            { name: "系统设置", to: { name: "adminSetSystemHome" } },
            { name: "数据校准", to: { name: "DiffSet" } },
            {
              name: "恢复出厂设置",
              handler: async function () {
                _this
                  .$confirm("确定恢复出厂设置？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  })
                  .then(async () => {
                    try {
                      let res = await _this.$myRequest({
                        url: "/post-restore-config",
                        method: "post",
                        data: {},
                      });

                      ElNotification({
                        title: "提示",
                        message: "操作成功",
                        type: "success",
                      });

                      _this.$router.push({ name: "DeviceSet" });
                    } catch (err) {
                      console.log("err net config");
                      console.log(err);
                    }
                  })
                  .catch(() => {});
              },
            },
          ],
        },
      ],
    };
  },
  mounted() {
    console.log(";;;;;;;;;;;");
    this.$store.commit("checkTick");
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
